// extracted by mini-css-extract-plugin
export default {"menuInput":"MenuInput_menuInput__atqx7"};